// 通用文案
export default {
  'fail5': '验证失败次数过多，请稍后再试',
  'httpcode-1': '网络异常，请稍后再试',
  'httpcode-400': '网络异常，请稍后再试',
  'httpcode-404': '网络异常，请稍后再试',
  'httpcode-500': '系统繁忙，请稍后再试',
  'httpcode-502': '系统繁忙，请稍后再试',
  'httpcode-503': '系统繁忙，请稍后再试',
  'httpcode-4xx': '网络异常，请稍后再试',
  'httpcode-5xx': '系统繁忙，请稍后再试',
  'httpcode-429': '操作过于频繁，请稍后再试',
  '-1': '请求错误，请稍后再试',
  '415': '请获取短信验证码',
  '108': '请输入图片验证码',
  '109': '请先拖动滑块进行安全验证',
  '110': '请先进行验证',
  '401': '操作超时，请刷新页面重试',
  '409': '您登录过于频繁,请稍后再试',
  '410': '超过IP限制，请稍候再试',
  '420': '账号不存在',
  '433': '系统繁忙，请刷新页面重试',
  '434': '您验证错误次数过多，请稍后再试',
  '435': '验证码错误次数过多，请明天再试',
  '436': '您验证错误次数过多，请稍后再试',
  '437': '验证码错误次数过多，请明天再试',
  '438': '已开启登录保护，请使用网页端登录',
  '500': '系统繁忙，请稍后再试',
  '502': '系统异常，请稍后再试',
  '503': '服务器繁忙，请稍候再试',
  '504': '次数超限，请稍候再试',
  '505': '次数超限，请稍候再试', // 服务器内部错误，请您稍后再试
  '601': '请求失败，请稍后再试', // pd pkid被禁用 不应该出现
  '455': {
    type: 'confirm',
    opt: {
      confirmCnt: '该账号无法使用，请重新注册其他账号',
      confirmTxt: '查看帮助',
      closeTxt: '取消',
      confirm: () => {
        window.open('https://hc.reg.163.com/iTerm/doc.html?id=561')
      }
    }
  },
  '452': {
    type: 'confirm',
    opt: {
      confirmTitel: '账号正在注销中',
      confirmCnt: '账号正在注销中，如需使用，请先撤销注销',
      confirmTxt: '撤销注销',
      closeTxt: '取消',
      confirm: () => {
        window.open('https://id.163.com/mail/logoutQuery.html')
      }
    }
  },
  '453': '该账号已经注销，请更换其他账号',
  '454': {
    type: 'confirm',
    opt: {
      confirmTitel: '绑定安全手机',
      confirmCnt: '如需使用该账号，请先绑定安全手机',
      confirmTxt: '绑定安全手机',
      closeTxt: '取消'
    }
  },
  '422': {
    type: 'confirm',
    opt: {
      confirmCnt: '该账号已被锁定，请前往账号安全中心申请解锁',
      confirmTxt: '账号安全中心',
      closeTxt: '取消',
      confirm: () => {
        location.href = 'https://id.163.com/mail/unlock.html'
      }
    }
  },
  '40110': '账号格式错误'
}



// WEBPACK FOOTER //
// ./src/util/codemapper.js